import { loadedAssets, loader } from "@/loader";
import { AsepriteResource } from "@excaliburjs/plugin-aseprite";
import { normalizeAttribute, parseSpriteDescription } from "./character";
import { ImageSource } from "excalibur";

type Clothing = {
  part: string; // Clothing part (e.g., "hr" for hair)
  type: string; // Type of the clothing (e.g., specific hair type)
};

export const loadByLook = async (look: string) => {
  const sprite = parseSpriteDescription(look);

  // Check if sprite or sprite.clothes is null or undefined
  if (!sprite || !Array.isArray(sprite.clothes)) {
    return []; // Return an empty array if there is no valid clothing data
  }

  const resources: any[] = [];

  // Iterate through all clothing items and load necessary resources
  await Promise.all(
    sprite.clothes.map(async (clothing: Clothing) => {
      // Check if clothing or its properties are valid
      if (!clothing || !clothing.part || !clothing.type) {
        return; // Skip this item if it's invalid
      }

      const attribute = normalizeAttribute(clothing.part);
      const resourcePath = `./public/figures/${attribute}/`;

      if (clothing.part === "hr") {
        // Specific handling for hair assets
        const resource = await loadResource(
          `hair/${clothing.type}`,
          "./public/figures/"
        );

        if (resource) {
          resources.push(resource); // Only push valid resources
        }
      }
    })
  );

  return resources;
};

export const loadResource = async (
  slug: string,
  path: string = "./public/furnitures/"
) => {
  if (loadedAssets[slug]) {
    await loadedAssets[slug].load(); // Ensure it's loaded before returning
    return loadedAssets[slug];
  }

  const resource = new AsepriteResource(`${path}${slug}/image.json`);
  loader.addResource(resource);
  loadedAssets[slug] = resource;

  await resource.load();
  return resource;
};

export const loadImageResource = async (
  slug: string,
  path: string = "./public/furnitures/"
) => {
  if (loadedAssets[slug]) {
    return loadedAssets[slug];
  }

  const resource = new ImageSource(`${path}${slug}`);
  loader.addResource(resource);
  loadedAssets[slug] = resource;

  await resource.load();

  return resource;
};
